import { URL_ACCOUNTS } from "./global";

export const accountsCallBack = (destination) => {
  let returnUrl = window.location.href;
  return (window.location.href = `${URL_ACCOUNTS}/${destination}?returnUrl=${returnUrl}`);
};
